var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmpsCharger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-SMPS_Charger"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SMPS_Charger",
    "data-name": "SMPS Charger",
    clipPath: "url(#clip-SMPS_Charger)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "charger",
    transform: "translate(0 9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M418.985,501.8H95.2V195.124a36.88,36.88,0,0,1,37-36.755h249.78a36.88,36.88,0,0,1,37,36.755V501.8Z",
    transform: "translate(0 -17.558)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 220.412,
    height: 372.149,
    transform: "translate(146.879 10.199)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_57",
    "data-name": "Ellipse 57",
    cx: 18.341,
    cy: 18.341,
    r: 18.341,
    transform: "translate(147.329 405.023)",
    fill: "#ff1d25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M212.816,285.177,256,328.362l43.186-43.185Z",
    transform: "translate(1.09 -10.681)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M381.93,143.089h-4.762V9.849A10.063,10.063,0,0,0,366.9,0H147.277a10.063,10.063,0,0,0-10.264,9.849V143.089h-4.762C106.2,143.089,85,163.429,85,188.432v296.16a10.063,10.063,0,0,0,10.264,9.849H418.919a10.063,10.063,0,0,0,10.264-9.849V188.432C429.183,163.429,407.986,143.089,381.93,143.089ZM157.543,19.7h199.1V359.384h-199.1ZM408.655,474.743H105.526V188.432c0-14.141,11.99-25.645,26.726-25.645h4.762V369.234a10.063,10.063,0,0,0,10.264,9.849H366.9a10.063,10.063,0,0,0,10.264-9.849V162.787h4.762c14.735,0,26.725,11.5,26.725,25.645V474.743Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M313.431,52.836H198.571a10.2,10.2,0,1,0,0,20.4h114.86a10.2,10.2,0,1,0,0-20.4Z",
    transform: "translate(1.09)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M313.431,104.522H198.571a10.2,10.2,0,1,0,0,20.4h114.86a10.2,10.2,0,1,0,0-20.4Z",
    transform: "translate(1.09 -3.733)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M165.226,412.384a28.54,28.54,0,1,0,28.54,28.54A28.572,28.572,0,0,0,165.226,412.384Zm0,36.683a8.142,8.142,0,1,1,8.142-8.142A8.151,8.151,0,0,1,165.226,449.067Z",
    transform: "translate(0.396 -17.558)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M299.186,274.978H212.815a10.2,10.2,0,0,0-7.213,17.411l43.185,43.185a10.2,10.2,0,0,0,14.424,0L306.4,292.389a10.2,10.2,0,0,0-7.21-17.411ZM256,313.939l-18.563-18.563h37.124Z",
    transform: "translate(1.09 -10.767)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M365.119,430.726H354.781a10.2,10.2,0,1,0,0,20.4h10.338a10.2,10.2,0,1,0,0-20.4Z",
    transform: "translate(1.818 -17.558)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M313.431,430.726h-85a10.2,10.2,0,0,0,0,20.4h85a10.2,10.2,0,1,0,0-20.4Z",
    transform: "translate(1.228 -17.558)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmpsCharger);
export default __webpack_public_path__ + "static/media/SMPS Charger.0b98b4fd867276eafbaa1263bdaf4f35.svg";
export { ForwardRef as ReactComponent };